import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DataContext } from "../../providers/DataProvider";
import { DataHandlerContext } from "../../providers/DataHandlerProvider";
import TopTitle from "../buttons/TopTitle";

function EditEvent() {
  const {
    eventSeriesData,
    eachEventSerieData,
    handlePopulateEventSeries,
    handlePopulateEachEventSeries,
    loading,
    error,
    numbOfEvents,
    setNumbOfEvents,
  } = useContext(DataContext);
  const {
    handleSubmitEventEdit,
    errorSubmit,
    loadingSubmit,
    handleSubmitSubmissionEdit,
  } = useContext(DataHandlerContext);

  const { eventseriesid, eventid } = useParams();

  const [apiDataHandle, setApiDataHandle] = useState({});
  const [apiSubmissionHandle, setApiSubmissionHandle] = useState({});
  const [sucesssFullySubmitted, setSuccessfullySubmitted] = useState(false);
  const [loadSubmissions, setLoadSubmissions] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setApiDataHandle((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmissionInputChange = (e, subId) => {
    const { name, value } = e.target;
    setApiSubmissionHandle((prev) => ({
      ...prev,
      [subId]: {
        ...prev[subId],
        [name]: value,
      },
    }));
  };

  const handleSubmit = async (
    e,
    eventSeriesId,
    eventId,
    data,
    submissionData
  ) => {
    
    e.preventDefault();
    console.log("Submitting data:", submissionData);
     

    try {
      if (Object.entries(data).length !== 0) {
        console.log("Data Route", data);

        const eventResponse = await handleSubmitEventEdit(
          eventSeriesId,
          eventId,
          data
        );
        if (eventResponse.status === 200) {
          setSuccessfullySubmitted(true);
          setTimeout(() => {
            setSuccessfullySubmitted(false);
           
          }, 3000);

          
        }
      }

      if (submissionData) {
        const submissionResponse = await handleSubmitSubmissionEdit(
          eventSeriesId,
          eventId,
          submissionData
        );

       console.log("Submission Response:", submissionResponse);
        if (submissionResponse[0].status === 200) {
          console.log("Submission Response:", submissionResponse);
          setSuccessfullySubmitted(true);
         
         
          
          setTimeout(() => {
            setSuccessfullySubmitted(false);
           
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Error submitting:", error);
    }
  };


  const getSortedSubmissions = () => {
    return eachEventSerieData.submissions
      ?.sort((a, b) => {
        if (a.submitted_at && b.submitted_at) {
          const dateA = new Date(a.submitted_at);
          const dateB = new Date(b.submitted_at);
          return dateB - dateA;
        }

        if (a.submitted_at) return -1;
        if (b.submitted_at) return 1;

        //Sort by alphabetical order if both dates are null
        return a.first_name.localeCompare(b.first_name);
      });
  };


  useEffect(() => {
    // setLoadSubmissions(true);
    // if(eachEventSerieData.submissions){
    //   setLoadSubmissions(false);
    // }
    handlePopulateEachEventSeries(`${eventseriesid}/event/${eventid}`);
  }, [setApiDataHandle]);

  return (
    <div className="flex flex-col min-h-screen">  
      
      <div className="  flex justify-center  mt-8   ">
        {errorSubmit && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded fixed top-0 mt-5"
            role="alert"
          >
            <strong className="font-bold">Error: </strong>
            <span className="block sm:inline">
              An error has been trying to save the data.
            </span>
          </div>
        )}
          {sucesssFullySubmitted && (
            <div
              className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded fixed top-0 mt-5 "
              role="alert"
            >
              <strong className="font-bold">Success! </strong>
              <span className="block sm:inline">
                Your data has been saved successfully.
              </span>
            </div>
          )}
      </div>
      <TopTitle title="Edit an event" />

       
      <div className="flex justify-between md:px-[20rem]   py-10 items-center md:space-x-4 ">
        <input
          name="event_title"
          type="text"
          onChange={handleInputChange}
          value={apiDataHandle.event_title || ""}
          placeholder={eachEventSerieData.event_title}
          className="text-5xl font-extrabold border w-full   border-black px-4 py-2"
        />
      </div>

      <div className=" md:px-[20rem]  items-center md:space-x-4">
        <form className="flex flex-col ">
          <label className="border-[2px]  px-4 py-2 mt-4 border border-black text-lg">
            Event settings
          </label>

         
          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1 text-lg">
              Show on Form
            </label>
            <input
              onChange={(e) => {
                  
                setApiDataHandle((prev) => {
                  return {
                    ...prev,
                    show_on_form: e.target.checked,
                  };
                });
              }}
              name="show_on_form"
              className=" px-4 py-3 mt-4 border-[2px] border-black w-full flex-1 appearance-none bg-gray-100 rounded-full checked:bg-green-300 cursor-pointer transition-colors duration-300"
              type="checkbox"
              checked={
                apiDataHandle.show_on_form ?? eachEventSerieData.show_on_form
              }
            />
          </div>

          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1 text-lg">
              Google Calendar ID:
            </label>
            <input
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="text"
              name="google_calendar_id"
              onChange={handleInputChange}
              placeholder="Enter Google Calendar ID"
              value={
                apiDataHandle.google_calendar_id ??
                eachEventSerieData.google_calendar_id
              }
            />
          </div>

          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1 text-lg">
              Target Participants:
            </label>
            <input
              name="target_participants"
              onChange={(e) =>
                setApiDataHandle((prev) => ({
                  ...prev,
                  target_participants: Number(e.target.value),
                }))
              }
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="number"
              placeholder="Enter target participants"
              value={
                apiDataHandle.target_participants ??
                eachEventSerieData.target_participants
              }
            />
          </div>

          <div className="flex items-center text-lg">
            <label className=" px-4 py-2 mt-4 flex-1">
              Maximum Participants:
            </label>
            <input
              name="maximum_participants"
              onChange={(e) =>
                setApiDataHandle((prev) => ({
                  ...prev,
                  maximum_participants: Number(e.target.value),
                }))
              }
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="number"
              placeholder="Enter maximum participants"
              value={
                apiDataHandle.maximum_participants ??
                eachEventSerieData.maximum_participants
              }
            />
          </div>

          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1 text-lg">Date:</label>
            <input
              name="date"
              onChange={(e) => {
                const inputValue = e.target.value;
                const date = new Date(inputValue);
                const tzOffset = date.getTimezoneOffset();
                const utcDate = new Date(date.getTime() - (tzOffset * 60000));

                setApiDataHandle((prev) => ({
                  ...prev,
                  date: utcDate.toISOString(),
                }));
              }}
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="datetime-local"
              placeholder="Enter date"
              value={
                apiDataHandle.date || eachEventSerieData.date
                  ? new Date(apiDataHandle.date ?? eachEventSerieData.date)
                      .toISOString()
                      .slice(0, 16)
                  : new Date().toISOString().slice(0, 16)
              }
            />
          </div>
          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1 text-lg">
              Copper Tag:
            </label>
            <input
              onChange={handleInputChange}
              name="copper_tag"
              value={apiDataHandle.copper_tag ?? eachEventSerieData.copper_tag}
               className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="text"
              placeholder="Enter copper tag"
            />
          </div>

          <table className="table-auto mt-10">
            <thead>
              <tr className="bg-slate-200 py-10 border-b-2 border-black ">
                <th className="px-2 py-4 text-left">First Name</th>
                <th className="px-2 py-4 text-left">Last Name</th>
                <th className="px-2 py-4 text-left">Organisation</th>
                <th className="px-2 py-4">Job Title</th>
                <th className="px-2 py-4">Email</th>
                <th className="px-2 py-4">Marketing</th>
              </tr>
            </thead>

            <tbody>
              {loadSubmissions && <p>Loading...</p>}
              {getSortedSubmissions()?.map((submission, key) => (
                <tr key={key} className="">
                  <td className="px-2 py-2">
                    <input
                      type="text"
                      className="border border-black w-full "
                      name="first_name"
                      onChange={(e) =>
                        handleSubmissionInputChange(e, submission.id)
                      }
                      value={
                        apiSubmissionHandle[submission.id]?.first_name ??
                        submission.first_name
                      }
                    />
                  </td>
                  <td className="px-2 py-2">
                    <input
                      name="last_name"
                      onChange={(e) =>
                        handleSubmissionInputChange(e, submission.id)
                      }
                      type="text"
                      className="border border-black w-full"
                      value={
                        apiSubmissionHandle[submission.id]?.last_name ??
                        submission.last_name
                      }
                    />
                  </td>
                  <td className="px-2 py-2">
                    <input
                      name="organisation"
                      onChange={(e) =>
                        handleSubmissionInputChange(e, submission.id)
                      }
                      type="text"
                      className="border border-black w-full"
                      value={
                        apiSubmissionHandle[submission.id]?.organisation ??
                        submission.organisation
                      }
                    />
                  </td>
                  <td className="px-2 py-2">
                    <input
                      name="job_title"
                      onChange={(e) =>
                        handleSubmissionInputChange(e, submission.id)
                      }
                      type="text"
                      className="border border-black w-full"
                      value={
                        apiSubmissionHandle[submission.id]?.job_title ??
                        submission.job_title
                      }
                    />
                  </td>
                  <td className="px-2 py-2">
                    <input
                      name="email"
                      onChange={(e) =>
                        handleSubmissionInputChange(e, submission.id)
                      }
                      type="text"
                      className="border border-black w-full"
                      value={
                        apiSubmissionHandle[submission.id]?.email ??
                        submission.email
                      }
                    />
                  </td>
                  <td className="px-2 py-2 text-center">
                    <input
                      onChange={(e) =>
                        setApiSubmissionHandle((prev) => ({
                          ...prev,
                          [submission.id]: {
                            ...prev[submission.id],
                            accepts_marketing: e.target.checked,
                          },
                        }))
                      }
                      name="accepts_marketing"
                      className="border-[2px] h-6 border-black w-10 appearance-none bg-gray-100 rounded-full checked:bg-green-300 cursor-pointer transition-colors duration-300"
                      type="checkbox"
                      checked={
                        apiSubmissionHandle[submission.id]?.accepts_marketing ??
                        submission.accepts_marketing
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          <button
            onClick={(e) => {
              handleSubmit(
                e,
                eventseriesid,
                eventid,
                apiDataHandle,
                apiSubmissionHandle
              );
            }}
            disabled={
              (Object.keys(apiSubmissionHandle).length === 0 &&
                Object.keys(apiDataHandle).length === 0) ||
              loadingSubmit
            }
            className={`border-[2px] px-4 py-2 mt-4 font-medium rounded-md transition-all duration-200 sticky bottom-4 shadow-sm ${
              (Object.keys(apiSubmissionHandle).length === 0 &&
                Object.keys(apiDataHandle).length === 0) ||
              loadingSubmit
                ? "bg-blue-100 border-blue-300 text-blue-400 cursor-not-allowed opacity-70"
                : "bg-green-500 border-green-600 text-white hover:bg-green-600 active:bg-green-700"
            }`}
          >
            {loadingSubmit ? (
              <span className="flex items-center gap-2">
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Loading...
              </span>
            ) : (
              "Save changes"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditEvent;
